import React from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings'
import withStyle, { StyledNoteBubble } from './NoteCounter.style.js'

const NoteCounter = ({ className, size, showIcon }) => (
  <div className={className}>
    {showIcon && <StyledNoteBubble />}
    {strings.notes_counter(size)}
  </div>
)

NoteCounter.defaultProps = {
  showIcon: true,
}

NoteCounter.propTypes = {
  /** Make sure to comment */
  /** Classname */
  className: PropTypes.string,
  /** Number of notes */
  size: PropTypes.number,
  showIcon: PropTypes.bool,
}

export default withStyle(NoteCounter)
